import { gql } from '@apollo/client';
import React from 'react';
import { CarouselPumoModuleSliderFragment } from '../../generated/types/CarouselPumoModuleSliderFragment';
import { CarouselCell, CAROUSEL_CELL_FRAGMENT } from '../Grid';
import { SwiperCarousel } from '../SwiperCarousel';
import './CarouselPumoModuleSlider.scss';

export const CAROUSEL_PUMO_MODULE_SLIDER_FRAGMENT = gql`
  fragment CarouselPumoModuleSliderFragment on CarouselPumoModule {
    cells {
      ...CarouselCellFragment
    }
  }
  ${CAROUSEL_CELL_FRAGMENT}
`;

interface Props {
  carouselPumoModuleSlider: CarouselPumoModuleSliderFragment;
}

export const CarouselPumoModuleSlider: React.FC<Props> = ({ carouselPumoModuleSlider }) => {
  return (
    <SwiperCarousel>
      {carouselPumoModuleSlider.cells.map((carouselCell, i) => (
        <CarouselCell key={i} carouselCell={carouselCell} />
      ))}
    </SwiperCarousel>
  );
};
